export const FS_EVENTS = {
  PROJECTDIGEST_EMBED_CLICKED: 'projectdigest_embed_clicked',
  PROJECTDIGEST_LINK_CLICKED: 'projectdigest_link_clicked'
};
